import { render, staticRenderFns } from "./GroupTaskCard.vue?vue&type=template&id=ee1a8f96"
import script from "./GroupTaskCard.vue?vue&type=script&lang=js"
export * from "./GroupTaskCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports